var BASE_FOCUSABLE_SELECTORS = [
    'a[href]',
    'area[href]',
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    'select:not([disabled]):not([aria-hidden])',
    'textarea:not([disabled]):not([aria-hidden])',
    'button:not([disabled]):not([aria-hidden])',
    'iframe',
    'object',
    'embed',
    '[contenteditable]',
    '[tabindex]:not([tabindex^="-"])',
];
function getFocusableNodesIn(container) {
    return Array.prototype.slice.call(container.querySelectorAll(BASE_FOCUSABLE_SELECTORS));
}
export function traverseFocusIn(container, e, isReverse) {
    if (isReverse === void 0) { isReverse = e === null || e === void 0 ? void 0 : e.shiftKey; }
    var focusableNodes = getFocusableNodesIn(container);
    if (focusableNodes.length === 0) {
        return;
    }
    var focusedIndex = focusableNodes.indexOf(document.activeElement);
    var focusElement;
    if (focusedIndex < 0) {
        focusElement = focusableNodes[0];
    }
    else {
        var nextFocusIndex = (focusedIndex + (isReverse ? -1 : 1) + focusableNodes.length) % focusableNodes.length;
        focusElement = focusableNodes[nextFocusIndex];
    }
    focusElement.focus();
    focusElement.scrollIntoView();
    e === null || e === void 0 ? void 0 : e.preventDefault();
}
var activeElement = null;
export function saveFocus() {
    activeElement = document.activeElement;
}
function runRestoreFocus() {
    activeElement === null || activeElement === void 0 ? void 0 : activeElement.focus();
    activeElement = null;
}
export function restoreFocus() {
    if (!activeElement) {
        return;
    }
    if (activeElement.tagName === 'BUTTON') {
        setTimeout(runRestoreFocus, 0);
    }
    else {
        runRestoreFocus();
    }
}
